import React from 'react';
import { motion } from 'framer-motion';
import { Users, Award, Zap, Target } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const programs = [{
  title: 'Beginner Tae Kwon Do',
  description: 'Our Beginner Taekwondo students, 5 years old and older, learn the fundamentals of Tae Kwon Do. They learn basic kicks, blocks, and strikes. They will develop self-discipline, respect, and confidence.',
  icon: Users,
  imagePosition: 'right' as const,
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.nwblackbelt.com/uploaded/images/Classes/BEGINNER%20TAE%20KWON%20DO.png',
  imageAlign: 'center' as const
}, {
  title: 'Intermediate Taekwondo',
  description: 'Students in the Intermediate Taekwondo class will continue to be taught more advanced techniques of the basic fundamentals. They will learn more advanced kicking, blocking, and striking techniques. They will also be introduced to sparring and forms. They will continue to develop their confidence and discipline as they continue to train and test for their next belt rank.',
  icon: Target,
  imagePosition: 'left' as const,
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.nwblackbelt.com/uploaded/images/Classes/INTERMEDIATE%20TAEKWONDO.png',
  imageAlign: 'top' as const
}, {
  title: 'Family Class',
  description: "Family class is great! Moms, Dads, and siblings. It is a great way to spend time together and learn something new. It's a great way to get in shape, develop self-discipline and increase your family bond. Try it, flexibility and confidence at the same time. Great for all relationships.",
  icon: Users,
  imagePosition: 'right' as const,
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.nwblackbelt.com/uploaded/images/Classes/FAMILY%20CLASS.png',
  imageAlign: 'top' as const
}, {
  title: 'Black Belt & Bodan Program',
  description: 'Our Black Belt & Bodan program takes what is a solid commitment to our Taekwondo for our upper belts. It is a journey that starts at 1st Gup (red belt with black stripe) and continues through 1st Dan (1st degree black belt). Students in this program are developing their leadership skills, and are also learning to be a role model for our younger students. They are at the highest level of our program and are role models.',
  icon: Award,
  imagePosition: 'left' as const,
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.nwblackbelt.com/uploaded/images/Classes/BLACK%20BELT%20%26%20BODAN%20PROGRAM.png',
  imageAlign: 'center' as const
}, {
  title: 'Hyper Pro Training',
  description: 'HPT (Hyper-pro-training) is a program that is for the elite athletes that have a strong desire to compete and win at the highest level. This program is designed to take the athletes to the next level. It is designed to develop speed, power, and technique. This program is for serious athletes.',
  icon: Zap,
  imagePosition: 'right' as const,
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.nwblackbelt.com/uploaded/images/Classes/HYPER%20PRO%20TRAINING.png',
  imageAlign: 'center' as const
}, {
  title: 'Juice Compound',
  description: "Juice Compound is a 30-45 minute class training program that focuses on will power to increase the athlete's endurance, strength, and speed. The program is designed to enhance their skills. The program is used for our competitive team as well as our students to increase their overall fitness level and mental toughness. It is a great way to train.",
  icon: Zap,
  imagePosition: 'left' as const,
  image: 'https://drwzpk38qkpfb.cloudfront.net/www.nwblackbelt.com/uploaded/images/Classes/JUICE%20COMPOUND.png',
  imageAlign: 'top' as const
}];
export function ProgramsList() {
  return <section className="py-20 px-4 bg-white" data-id="element-343">
      <div className="max-w-6xl mx-auto space-y-24" data-id="element-344">
        {programs.map((program, idx) => <motion.div key={idx} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className={`grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 ${program.imageAlign === 'top' ? 'items-start' : 'items-center'} ${program.imagePosition === 'left' ? 'md:grid-flow-dense' : ''}`} data-id="element-345">
            {/* Text Content */}
            <div className={program.imagePosition === 'left' ? 'md:order-2' : ''} data-id="element-346">
              <div className="flex items-center gap-3 mb-4" data-id="element-347">
                <div className="w-12 h-12 bg-[#1e3a8a] rounded-lg flex items-center justify-center border-2 border-[#a3d977]/30" data-id="element-348">
                  <program.icon className="w-6 h-6 text-[#a3d977]" data-id="element-349" />
                </div>
                <h2 className="text-2xl sm:text-3xl font-black text-[#0f1f3d]" data-id="element-350">
                  {program.title}
                </h2>
              </div>
              <p className="text-gray-600 leading-relaxed text-lg" data-id="element-351">
                {program.description}
              </p>
            </div>

            {/* Real Class Image */}
            <div className={`${program.imagePosition === 'left' ? 'md:order-1' : ''}`} data-id="element-352">
              <div className="relative aspect-[4/3] bg-gray-100 rounded-2xl overflow-hidden shadow-lg border-2 border-[#a3d977]/20" data-id="element-353">
                <img src={program.image} alt={program.title} className={`w-full h-full ${program.imageAlign === 'top' ? 'object-cover object-top' : 'object-cover'}`} data-id="element-354" />
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}